import React from "react"
import PropTypes from 'prop-types';
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Banner extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [ 
        //pode ser string ou objeto caso necessite de alguma config especifica
        {
          title : 'left',
          isDefault: true
        },
        'right'
      ],
      modifiers : [ 
        {
          title : 'white',
          isDefault : true
        },
        'transparent'
      ],
      states : []
    }

  }

  render() {
    const { right, backgroundColorToken, backgroundImageSrc, children, ...rest } = this.props
    const props = clearProps(this.props)
    return  <div {...rest} className={resolveProps(this.props, this.config, 'Banner')+ ' mdn-Banner--slide'}>
      <div className="mdn-Banner-wrapper">
        <div className="mdn-Banner-item" style={{backgroundImage: `url(${backgroundImageSrc})`, backgroundColor: `${backgroundColorToken}`}}>
          <div className="mdn-Container">
            <div className={right ? 'mdn-Row mdn-u-justifyContent-xs-end' : 'mdn-Row' }>
              <div className="mdn-Col-xs-12 mdn-Col-md-6">
                <div className="mdn-Banner-shape">
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

Banner.propTypes = {
  children : PropTypes.node,
  backgroundImageSrc :  PropTypes.string,
  right: PropTypes.bool,
  backgroundColorToken : PropTypes.string
}